import React from "react";
import {
  ColumnLayoutItem,
  TwoColumnLayoutWrapper,
} from "../../common/Common.style";
import {
  CLINICIAN_ROLES,
  FilterDataType,
  USER_TYPE,
} from "@home-health-notify/domain";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "hhn-commons";

type UserRoleFiltersProps = {
  departments: CLINICIAN_ROLES[];
  filterData: FilterDataType;
  onUserRoleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLabelClick: (
    value: string | USER_TYPE,
    filterDataKey: keyof FilterDataType,
  ) => void;
};

const UserRoleFilters = ({
  departments,
  filterData,
  onUserRoleChange,
  onLabelClick,
}: UserRoleFiltersProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "userDirectory" });

  return (
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="accordion-content"
      >
        <Typography>{tNs("filter.userRole")}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <TwoColumnLayoutWrapper data-testid="user-role-checkbox-container">
          {departments.map(function (department: CLINICIAN_ROLES) {
            return (
              <ColumnLayoutItem key={department} columns={4}>
                <Checkbox
                  value={department}
                  onChange={onUserRoleChange}
                  checked={filterData.userRole.includes(department)}
                />
                <Typography
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => onLabelClick(department, "userRole")}
                >
                  {department}
                </Typography>
              </ColumnLayoutItem>
            );
          })}
        </TwoColumnLayoutWrapper>
      </AccordionDetails>
    </Accordion>
  );
};

export default UserRoleFilters;
